/* GENERATED by scripts/gen-data.mjs — film scene "f-guard" (from s1.js + s2.js).
 * Structure only: every string is an i18n key resolved from
 * src/i18n/locales/<lang>/. Edit the content in the artifact and re-run
 * npm run extract, do not hand-edit here. */

import type { FilmScene } from '../../types';

export const F_GUARD: FilmScene = {
  "w": 640,
  "h": 300,
  "items": [
    {
      "k": "box",
      "id": "rq",
      "x": 14,
      "y": 124,
      "w": 126,
      "h": 56,
      "lKey": "films:f-guard.items.rq.l"
    },
    {
      "k": "wire",
      "id": "w1",
      "from": "rq",
      "to": "gd"
    },
    {
      "k": "box",
      "id": "gd",
      "x": 172,
      "y": 124,
      "w": 160,
      "h": 56,
      "lKey": "films:f-guard.items.gd.l",
      "sKey": "films:f-guard.items.gd.s"
    },
    {
      "k": "wire",
      "id": "w2",
      "from": "gd",
      "to": "ok",
      "dash": true
    },
    {
      "k": "box",
      "id": "ok",
      "x": 388,
      "y": 44,
      "w": 150,
      "h": 56,
      "lKey": "films:f-guard.items.ok.l",
      "sKey": "films:f-guard.items.ok.s"
    },
    {
      "k": "wire",
      "id": "w3",
      "from": "gd",
      "to": "hu",
      "dash": true
    },
    {
      "k": "box",
      "id": "hu",
      "x": 388,
      "y": 204,
      "w": 150,
      "h": 56,
      "lKey": "films:f-guard.items.hu.l",
      "sKey": "films:f-guard.items.hu.s"
    },
    {
      "k": "note",
      "id": "n1",
      "x": 14,
      "y": 212,
      "lKey": "films:f-guard.items.n1.l"
    }
  ],
  "steps": [
    {
      "on": [
        "rq",
        "w1"
      ],
      "hot": [
        "rq",
        "w1"
      ],
      "capKey": "films:f-guard.steps.0.cap"
    },
    {
      "on": [
        "rq",
        "gd",
        "w1"
      ],
      "hot": [
        "gd"
      ],
      "capKey": "films:f-guard.steps.1.cap"
    },
    {
      "on": [
        "rq",
        "gd",
        "w1",
        "hu",
        "w3",
        "n1"
      ],
      "hot": [
        "hu",
        "w3"
      ],
      "capKey": "films:f-guard.steps.2.cap"
    },
    {
      "on": [
        "rq",
        "gd",
        "w1",
        "ok",
        "w2",
        "n1"
      ],
      "hot": [
        "ok",
        "w2"
      ],
      "capKey": "films:f-guard.steps.3.cap"
    }
  ]
};
